import { createFileRoute } from '@tanstack/react-router';

import InstitutionDetails from '@/ui/pages/InstitutionDetails/InstitutionDetails';

export const Route = createFileRoute('/_dashboard/institutions/$id/')({
  component: InstitutionDetails,
});
